import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilService } from './../../../services/util.service';
import { ErrorInterceptor } from './../../interceptors/error.interceptor';
import { AuthInterceptor } from './../../interceptors/auth.interceptor';
//import { MaterialBaseModule } from '../material-base.module';
import { AlertService } from './../../../services/alert.service';
import { ToastrModule } from 'ngx-toastr';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Injectable } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialBaseModule } from '../material-base.module';
//import { TooltipModule } from 'ng2-tooltip-directive';

@Injectable()
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FlexLayoutModule,
    ToastrModule.forRoot(),
  //  TooltipModule,
    MaterialBaseModule,
  ],
  providers: [
    AlertService,
    UtilService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
  ],
  exports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FlexLayoutModule,
    ToastrModule,
    MaterialBaseModule,
   // TooltipModule,
  ]
})
export class BaseModule { }
